/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:37:01
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-07-19 16:58:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/ButtonText/index.tsx
 */
import React from 'react';

import { Input, OriSelect } from '@/src/components/Antd';
import { useDispatch } from 'react-redux';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  errKey,
  validateButtonText,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools';
import {
  EnumCollapseId,
  getButtonStyle,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  // fetchContentShoppingCartResetConfig,
  getSubmitStamp,
  onButtonTextChange,
  onCollapseOpen,
  onErrorChange,
} from '../slice';

import { getI18nFromGeneral } from '@/src/tools/tools';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { resetConfig } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/common';
import { store } from 'src/store';
import { i18nGet } from 'src/tools/tools';
import styles from './css.less';

const Option = OriSelect.Option;

const SearchBarPlaceHolder = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, specificError, isPrimary, themeList, withoutCollapse } = props;

  const _d = useDispatch();
  const textErr = specificError[errKey.buttonTextTextErr];
  const { text, buttonThemeUuid } = data || {};

  const handleOnButtonTextChange = (e) => {
    _d(onButtonTextChange(e));
  };

  const handleOnThemeChange = (buttonThemeUuid) => {
    _d(onButtonTextChange({ buttonThemeUuid }));
  };

  return (
    <Section
      size='small'
      className={withoutCollapse ? styles.fieldSection : ''}>
      {isPrimary && (
        <ItemWrapper
          size='small'
          title={getI18n('salesChannelContent.index.addToCartButtonTheme')}>
          <OriSelect
            value={buttonThemeUuid || null}
            size='large'
            onChange={handleOnThemeChange}>
            <Option value={null}>{getI18n('general.status.none')}</Option>
            {(themeList || []).map((i) => {
              const { uuid, name } = i;
              return (
                <Option value={uuid} key={uuid}>
                  {name}
                </Option>
              );
            })}
          </OriSelect>
        </ItemWrapper>
      )}

      <ItemWrapper
        title={`${getI18n('general.buttonText')}*`}
        size='small'
        rightPart={`${text.length}/40`}>
        <Input
          maxLength={40}
          error={(textErr || []).length > 0}
          help={(textErr || []).join(' ')}
          size='large'
          value={text}
          placeholder={getI18n(
            'salesChannelContent.index.pleaseinputbuttontext',
          )}
          onChange={(e) => {
            handleOnButtonTextChange({ text: e });
          }}
        />
      </ItemWrapper>
    </Section>
  );
};
export default ErrorProcessingHOC(SearchBarPlaceHolder, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.buttonStyle,
  getContent: getButtonStyle,
  title: getI18nFromGeneral('general.hOCTitle.buttonText'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateButtonText(x, !isPrimary);
  },
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          resetConfig({
            dispatch: store.dispatch,

            key: 'buttonStyle',
          });
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
